<template>
  <div>
    <!-- <div
    class="topImage"
      style="
        width: 100%;
        height: 277px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        
      "
    >
      <img
        src="../../assets/images/top-img.png"
        alt=""
        style="width: 1920px; height: 277px; margin: 0 auto"
      />
    </div> -->

    <!-- <div class="nav">
      <div class="nav-box">
        <div
          v-for="item in navItems"
          :key="item.name"
          @click="selectPage(item.name)"
          :class="{ active: item.name === currentPage }"
        >
          {{ item.label }}
        </div>
        <div
          @click="selectPage('BackManagement')"
          :class="{ active: 'BackManagement' === currentPage }"
        >
          后台管理
        </div>
      </div>
    </div> -->
    <!-- <div style="width: 1120px; margin: 0 auto; background-color:#f0f5ff"></div> -->
    <!-- <div class="content"> -->
    <div>
      <component :is="currentPage" ref="currentPageComponent"></component>
    </div>
  </div>
</template>

<script>
import HomePage from "../HomePage/index.vue";
import OrganizationPage from "../OrganizationPage/index.vue";
import OnlineOffice from "../OnlineOffice/index.vue";
import BackManagement from "../BackManagement/index.vue";
import CommunicationManual from "../CommunicationManual/index.vue";
import SoftwareDownload from "../SoftwareDownload/index.vue";
import TextAll from "../TextAll/index.vue";
import CleanGover from "../CleanGover/index.vue";
import SfjsIframe from "./SfjsIframe.vue";

export default {
  data() {
    return {
      navItems: [
        { name: "HomePage", label: "首页" },
        { name: "OrganizationPage", label: "组织机构" },
        { name: "OnlineOffice", label: "在线办公" },
        { name: "SoftwareDownload", label: "下载中心" },
        { name: "CommunicationManual", label: "法律法规" },
        { name: "SfjsIframe", label: "算法竞赛" },
        // { name: 'BackManagement', label: '后台管理' },
      ],
      currentPage: "", // 默认显示 Home 组件
      ids:'',
      imgid:'',
      organization:'',
    };
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    this.ids = params.get("ids");
    this.imgid = params.get("imgid");
    this.organization = params.get("organization");
    if(this.ids){
      this.currentPage='TextAll'
      return
    }
    if(this.imgid){
      this.currentPage='CleanGover'
      return
    }
    if(this.organization){
      this.currentPage='OrganizationPage'
      return
    }
    this.currentPage="SfjsIframe"
  },
  methods: {
    selectPage(page) {
      if (page === "BackManagement") {
        //window.open("http://59.203.187.199:9099/login");
        // window.open("http://36.33.216.70:8076/login");
        return;
      }
      if (page === "OnlineOffice") {
        window.open("http://59.203.194.83/Login.aspx");
        return;
      }
      if (page === "CommunicationManual") {
        window.open("http://59.255.109.24:82/FLFGWeb/flfg.aspx");
        return;
      }
      this.currentPage = page; // 切换当前页面
      if (page === "HomePage" && this.$refs.currentPageComponent.setShow) {
        this.$refs.currentPageComponent.setShow(true);
      }
    },
  },
  components: {
    HomePage,
    OrganizationPage,
    OnlineOffice,
    SoftwareDownload,
    CommunicationManual,
    BackManagement,
    TextAll,
    CleanGover,
    SfjsIframe,
  },
};
</script>

<style scoped lang="scss">
.topImage{
  background-image: url('@/assets/images/imgTop2.png');
}
.navbar {
  display: flex;
  background-color: #f8f8f8;
  padding: 10px;
}
.content {
  background: linear-gradient( 179deg, #4C97E2 0%, #F0F5FF 100%);
  min-height: calc(100vh - 315px);
  height: 100%;
}
.nav {
  width: 100%;
  height: 38px;
  margin: 0 auto;
  background: linear-gradient(to bottom, #144ea0, #165280);

  .nav-box {
    width: 1120px;
    height: 38px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;

    div {
      height: 32px;
      font-weight: bold;
      font-size: 16px;
      color: #fff;
      cursor: pointer;
      // text-align: center;
      margin-left: 16px;
      margin-right: 18px;
      line-height: 38px;
    }

    .active {

      border-bottom: solid 2px #FFF;
    }
  }
}

.nav-item {
  margin: 0 15px;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.nav-item:hover {
  background-color: #e0e0e0;
}
</style>
